/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Desktop_Banner_MessageInputs */

const en_desktop_banner_message = /** @type {(inputs: Desktop_Banner_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get the full experience with our desktop app – video export, faster performance, and more features!`)
};

const fr_desktop_banner_message = /** @type {(inputs: Desktop_Banner_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profitez de l'expérience complète avec notre application de bureau – exportation vidéo, performances accrues et plus de fonctionnalités !`)
};

const de_desktop_banner_message = /** @type {(inputs: Desktop_Banner_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erleben Sie das volle Programm mit unserer Desktop-App – Videoexport, höhere Leistung und mehr Funktionen!`)
};

const it_desktop_banner_message = /** @type {(inputs: Desktop_Banner_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ottieni l'esperienza completa con la nostra app desktop: esportazione video, prestazioni più veloci e più funzionalità!`)
};

const ru_desktop_banner_message = /** @type {(inputs: Desktop_Banner_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получите максимум от нашего настольного приложения — экспорт видео, более высокая производительность и больше функций!`)
};

const es_desktop_banner_message = /** @type {(inputs: Desktop_Banner_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Obtenga la experiencia completa con nuestra aplicación de escritorio: exportación de video, rendimiento más rápido y más funciones!`)
};

const zh_cn2_desktop_banner_message = /** @type {(inputs: Desktop_Banner_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用我们的桌面应用程序，即可获得完整体验——视频导出、更快的性能和更多功能！`)
};

const ja_desktop_banner_message = /** @type {(inputs: Desktop_Banner_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`デスクトップ アプリで、ビデオのエクスポート、パフォーマンスの高速化、その他の機能など、完全なエクスペリエンスを実現しましょう。`)
};

const hi_desktop_banner_message = /** @type {(inputs: Desktop_Banner_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हमारे डेस्कटॉप ऐप के साथ संपूर्ण अनुभव प्राप्त करें – वीडियो निर्यात, बेहतर प्रदर्शन और अधिक सुविधाएं!`)
};

const pt_pt2_desktop_banner_message = /** @type {(inputs: Desktop_Banner_MessageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aproveite a experiência completa com nosso aplicativo para desktop: exportação de vídeos, desempenho mais rápido e mais recursos!`)
};

/**
* | output |
* | --- |
* | "Get the full experience with our desktop app – video export, faster performance, and more features!" |
*
* @param {Desktop_Banner_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const desktop_banner_message = /** @type {((inputs?: Desktop_Banner_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Desktop_Banner_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_desktop_banner_message(inputs)
	if (locale === "de") return de_desktop_banner_message(inputs)
	if (locale === "it") return it_desktop_banner_message(inputs)
	if (locale === "ru") return ru_desktop_banner_message(inputs)
	if (locale === "es") return es_desktop_banner_message(inputs)
	if (locale === "zh-CN") return zh_cn2_desktop_banner_message(inputs)
	if (locale === "ja") return ja_desktop_banner_message(inputs)
	if (locale === "hi") return hi_desktop_banner_message(inputs)
	if (locale === "pt-PT") return pt_pt2_desktop_banner_message(inputs)
	return en_desktop_banner_message(inputs)
});